import statesData from 'app/assets/jsons/State.json';

export const initialValueSetUp = (setValue, landsgtgDetails, supportList, waveandexList) => {
  setValue('pDateOfValidation', landsgtgDetails?.crimCheckDate);
  setValue('pI9OnFIle', landsgtgDetails?.i9Uploaded);
  setValue('pSupportDocOnFile', landsgtgDetails?.supportDocUploaded);
  setValue('pNamesAndNumbersMatch', landsgtgDetails?.namesNumbersMatchI9);
  setValue('pEVerifyCode', landsgtgDetails?.i9eVerifyCode);
  setValue('pEVerifyUpload', landsgtgDetails?.eVerifyDate);
  setValue('pNotAForeignTraveler', landsgtgDetails?.notForeignTraveler);
  setValue('pExceptionFollowUpDate', landsgtgDetails?.foreignTravelerFUDate);
  setValue(
    'pSupportDocList',
    supportList?.find(x => x.Id === landsgtgDetails?.supportDocListId?.toString())?.Description,
    { shouldDirty: true },
  );
  setValue('pExceptionWaiveEvent', landsgtgDetails?.missExpEvents);
  setValue('pFinalAuditCompleted', landsgtgDetails?.i9FinalAuditCompleted);
  setValue('pReason', landsgtgDetails?.checkStateReason, { shouldDirty: true });
  setValue(
    'piExWave',
    waveandexList?.find(x => x.Id === landsgtgDetails?.checkStateExceptId?.toString())?.Description,
    { shouldDirty: true },
  );
  setValue('pYes', landsgtgDetails?.checkState);
  setValue('pExpYes', landsgtgDetails?.noExpAssign);
  setValue('pEventsSet', landsgtgDetails?.missExpEvents);
  setValue('pAllVerified', landsgtgDetails?.allCertificationsVerified);
  setValue('pClientYes', landsgtgDetails?.packetNotRequired);
  setValue('pSentToClient', landsgtgDetails?.packetSentDate);
  setValue('licenseActive', landsgtgDetails?.licenseActive);
  setValue('licenseReviewCleared', landsgtgDetails?.licenseReviewTeamClearedHits);
  setValue('licenseMatchAudit', landsgtgDetails?.hitsOnLicenseMatchAudit);
  setValue('auditScreened', landsgtgDetails?.auditScreenedWithClient);
  setValue('datesCheckbox1', landsgtgDetails?.licenseIssuedAfterGraduation);
  setValue('datesCheckbox2', landsgtgDetails?.checkedDob);
  setValue('datesCheckbox3', landsgtgDetails?.confirmCaLicense);
  setValue('reason', landsgtgDetails?.confirmCaLicenseReason);
  setValue('proofOfResidency', landsgtgDetails?.isProofOfResidencyOnFileForCompact);
  setValue('pSingleYes', landsgtgDetails?.statesInNursys || false);
  setValue('pSingleNo', landsgtgDetails?.statesInNursys || false);
  setValue('pAddressesYes', landsgtgDetails?.nursysMatchOnFile || false);
  setValue('pAddressesNo', landsgtgDetails?.nursysMatchOnFile || false);
  setValue('pMatchesYes', landsgtgDetails?.nursysLastnameMatchesLicense || false);
  setValue('pMatchesNo', landsgtgDetails?.nursysLastnameMatchesLicense || false);
  setValue('pSingleReason', landsgtgDetails?.statesInNursysReason || '', { shouldDirty: true });
  setValue('pAddressesReason', landsgtgDetails?.nursysMatchOnFileReason || '', { shouldDirty: true });
  setValue('pMatchesReason', landsgtgDetails?.nursysLastnameNotMatchesLicenseReason || '', { shouldDirty: true });
};

export const getStateDesc = stateId => {
  return statesData.states.find(d => d.StateNumber === stateId)?.Description;
};
